<script lang="ts" setup>
import { useElementSize, useWindowScroll } from '@vueuse/core'

import AppFooter from '@Widgets/AppFooter.vue'
import AppHeader from '@Widgets/AppHeader.vue'
import ToastProvider from '@UI/Toast/ToastProvider.vue'

defineOptions({
  name: 'LayoutDefault',
})

const headerSticky = useTemplateRef('headerSticky')
const { height: headerHeight } = useElementSize(headerSticky)

const { y } = useWindowScroll()

const isSticky = computed(() => y.value > headerHeight.value)
</script>

<template>
  <div class="hiring-app">
    <slot name="header">
      <div :style="{ height: `${headerHeight}px` }">
        <div
          ref="headerSticky"
          class="header-sticky"
          :class="{ sticky: isSticky }"
        >
          <AppHeader />
        </div>
      </div>
    </slot>

    <slot />

    <slot name="footer">
      <AppFooter />
    </slot>

    <ToastProvider />
  </div>
</template>

<style scoped lang="scss" src="@scss/layouts/default.scss" />
